interface ColorSwatchProps {
  color: string;
  isSelected?: boolean;
  onClick: () => void;
}

const ColorSwatch = ({ color, isSelected, onClick }: ColorSwatchProps) => {
  const className = isSelected 
    ? "color-swatch color-swatch--selected" 
    : "color-swatch";

  return (
    <button
      className={className}
      style={{ backgroundColor: color }}
      onClick={onClick}
      aria-label={`Select color ${color}`}
    />
  );
};

export default ColorSwatch;
